module.exports = __webpack_public_path__ + "static/img/wxmb.56381ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wxmb.jpg
// module id = 4IQ8
// module chunks = 1